
import { defineComponent } from "vue";

const INSURANCE_OPTIONS = {
  none: "0",
  full: "1",
  light: "3",
};

export default defineComponent({
  name: "OptionalInsurance",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  computed: {
    insuranceOptions(): object {
      return INSURANCE_OPTIONS;
    },
  },
  created() {
    this.selectedInsurance = this.modelValue;
  },
  watch: {
    selectedInsurance: function (newVal) {
      this.$emit("update:modelValue", newVal);
    },
    modelValue: function (newVal) {
      this.selectedInsurance = newVal;
    },
  },
  data() {
    return {
      selectedInsurance: "",
    };
  },
});
